// ที่มาของการแจ้งลานักเรียน (tb_student_leave.source) → ป้ายกำกับที่แสดงให้ครูเห็น
// ค่ามาจาก ENUM ในฐานข้อมูล ดู migrations/20260712_add_student_leave_source.sql
// migrations/20260906_add_academic_leave_source.sql
// และ migrations/20260907_add_islamic_advisor_leave_source.sql
// ค่าเดิมก่อนมีคอลัมน์นี้เป็นของครูประจำชั้นทั้งหมด จึงถือ advisor เป็นค่าตั้งต้น
const LEAVE_SOURCE_LABELS = {
  advisor:    'ครูประจำชั้นแจ้ง',
  discipline: 'ฝ่ายปกครองแจ้ง',
  academic:   'หัวหน้าวิชาการแจ้ง',
  // ครูประจำชั้นภาคศาสนาแจ้งลาจากหน้าของตัวเอง แต่ลงตารางเดียวกัน — ครูสามัญจึงเห็นเลย
  islamic_advisor: 'ครูประจำชั้นศาสนาแจ้ง',
};

export const leaveSourceLabel = (source) =>
  LEAVE_SOURCE_LABELS[source] || LEAVE_SOURCE_LABELS.advisor;

// ป้ายในหน้าเช็คชื่อ — "…แจ้งลา"
export const leaveReportedByLabel = (source) => `${leaveSourceLabel(source)}ลา`;

export default LEAVE_SOURCE_LABELS;
